import {Component} from 'react'
import {NotificationManager} from 'react-notifications'

class MessageService extends Component {
	static sendMessage(kind, message, action, action_text, prompt_value) {
    const timeout = kind === 'error' ? 7000 : 3000;

    // Toast...
    switch (kind) {
      case 'success':
        NotificationManager.success(message, 'Success', timeout);
        break;
      case 'info':
        NotificationManager.info(message, 'Info', timeout);
        break;
      case 'warning':
        NotificationManager.warning(message, 'Warning', timeout);
        break;
      case 'error':
        NotificationManager.error(message, 'Error', timeout);
        break;
      case 'prompt':
        // AI Agent...
        let iframe_container = document.getElementById('ai-agent');
        let iframe = document.getElementById('ai-agent-iframe');
        
        if (iframe_container && iframe) {
          iframe.contentWindow.postMessage({
            type: 'ai-agent-message', 
            kind: kind,
            content: message,
            action: action,
            action_text: action_text,
            prompt_value: prompt_value
          }, "*");

          document.getElementById('root').classList.add('ai-agent-oppened');
        }

        break;
      default:
        NotificationManager.info(message, 'Info', timeout);
    }
	}
	
  static showSuccessNotification(message, action=null, action_text=null) {
		MessageService.sendMessage('success', message, action, action_text, null);
  }

  static showInfoNotification(message, action=null, action_text=null) {
		MessageService.sendMessage('info', message, action, action_text, null);
  }    

  static showWarningNotification(message, action=null, action_text=null) {
		MessageService.sendMessage('warning', message, action, action_text, null);
  }

  static showErrorNotification(message, action=null, action_text=null) {
		MessageService.sendMessage('error', message, action, action_text, null);
  }

  static showPromptNotification(message, prompt_value) {
    MessageService.sendMessage('prompt', message, null, null, prompt_value);
  }
}

export default MessageService;
